import { render } from "./AllService.vue?vue&type=template&id=498a78a9"
import script from "./AllService.vue?vue&type=script&lang=js"
export * from "./AllService.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__